import { z } from "zod";
/**
 * How a client carries its tokens.
 *
 * The only thing that differs between the support dashboard and the mobile app.
 * Modelling it as data — rather than as two authentication flows — is what keeps a
 * single issuance path: the transport is applied at the edge, after the principal
 * has already been established.
 */
export const tokenTransportSchema = z.enum(["cookie", "bearer"]);
/**
 * Why a session stopped being valid.
 *
 * Recorded on the session and in the audit log. `token_reuse_detected` is
 * deliberately distinct from `logout`: it means a rotated refresh token was
 * replayed, which is treated as theft and revokes the entire family.
 */
export const sessionRevocationReasonSchema = z.enum([
    "logout",
    "logout_all",
    "token_reuse_detected",
    "password_changed",
    "account_disabled",
    "admin_revoked",
]);
/** True once a session has been revoked or has passed its absolute expiry. */
export function isSessionActive(session, now) {
    if (session.revokedAt !== undefined)
        return false;
    return session.expiresAt.getTime() > now.getTime();
}
//# sourceMappingURL=session.js.map